const photoIcon = `
<svg width="20px" height="14px" viewBox="0 0 20 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Line_Icons</title>
    <desc>Created with Sketch.</desc>
    <g id="Dashboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Dashboard-empty-state-Copy" transform="translate(-322.000000, -597.000000)" fill="#00A3D9" fill-rule="nonzero">
            <g id="Photos-Copy" transform="translate(284.000000, 556.000000)">
                <g id="photo-landscape" transform="translate(36.000000, 36.000000)">
                    <g id="Line_Icons" transform="translate(2.000000, 4.000000)">
                        <g id="Group">
                            <path d="M18,0.999 L2,0.999 C0.897,0.999 0,1.896 0,2.999 L0,12.999 C0,14.102 0.897,14.999 2,14.999 L18,14.999 C19.103,14.999 20,14.102 20,12.999 L20,2.999 C20,1.896 19.103,0.999 18,0.999 Z M2,12.999 L2,2.999 L18,2.999 L18.001,12.999 L2,12.999 Z" id="Shape"></path>
                            <path d="M10,8.999 C8.159,8.999 7,10.159 7,11.999 L13,11.999 C13,10.159 11.841,8.999 10,8.999 Z" id="Path"></path>
                            <circle id="Oval" cx="10" cy="5.999" r="2"></circle>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default photoIcon;
